async function fetchData(url, options) {
	let response = '';
	if (options) {
		response = await fetch(url, {
			method: 'POST',
			body: options.body
		})	
	} else {
		response = await fetch(url);	
	}
	

	if (response.ok) { // если HTTP-статус в диапазоне 200-299
		try {
			let json = await response.json();
			return json;
		} catch {
			return response;
		}

	} 
}

export default fetchData;